import classNames from "classnames";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import { FC, useCallback, useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import axios from "../../../common/axios";
import Button from "../../../components/bootstrap/Button";
import Checks from "../../../components/bootstrap/forms/Checks";
import Input from "../../../components/bootstrap/forms/Input";
import Toasts from "../../../components/bootstrap/Toasts";
import Icon from "../../../components/icon/Icon";
import IconLogo from "../../../components/IconLogin";
import Logo from "../../../components/Logo";
import AuthContext from "../../../contexts/authContext";
import useDarkMode from "../../../hooks/useDarkMode";
import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";



interface ILoginProps {
  isSignUp?: boolean;
}
const Login: FC<ILoginProps> = ({ isSignUp }) => {
  const { setUser } = useContext(AuthContext);

  const { darkModeStatus } = useDarkMode();
  const { addToast } = useToasts();
  const navigate = useNavigate();
  const handleOnClick = useCallback(() => navigate("/"), [navigate]);
  const [isForgot, setIsForgot] = useState<boolean>(false);
  const [isSave,setIsSave]= useState<boolean>(false)

  const onLogin = (username: string, password: string) => {
    return axios
      .post("login", { username, password })
      .then((response) => {
        //console.log(response);
        //return response.data;
        localStorage.setItem("userData", JSON.stringify(response.data.result));
        localStorage.setItem("token", response.data.result.apiKey);
        localStorage.removeItem('accout')
        if(isSave) {
        localStorage.setItem("accout",JSON.stringify({username,password}));
        }
        if (setUser) {
          setUser(username);
        }
        handleOnClick();
      })
      .catch((err) => {
        formik.setFieldError(
          "loginPassword",
          "Tên đăng nhập hoặc mật khẩu không đúng Vui lòng kiểm tra lại!"
        );
      });
    //login(username, password);
    //return false;
    //return getUserDataWithUsername(username).password === password;
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      loginUsername: "",
      loginPassword: "",
    },
    validate: (values) => {
      const errors: { loginUsername?: string; loginPassword?: string } = {};

      if (!values.loginUsername) {
        errors.loginUsername = "Vui lòng nhập tên tài khoản";
      }

      if (!values.loginPassword) {
        errors.loginPassword = "Vui lòng nhập mật khẩu";
      }

      return errors;
    },
    validateOnChange: false,
    onSubmit: (values) => {
      if (values.loginUsername) {
        onLogin(values.loginUsername, values.loginPassword);
      }
    },
  });

  const formikforgotPass = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validate: (values) => {
      const errors: { email?: string } = {};

      if (!values.email) errors.email = "Tên tài khoản không được trống";
      // if (!validateEmail(values.email))
      //   errors.email = "email không đúng định dạng";

      return errors;
    },
    validateOnChange: false,
    onSubmit: (values) => {
      forgotPass(values.email);
    },
  });

  const forgotPass = (email: string) => {
    axios
      .get(`/forgotPassword/${email}`)
      .then((res) => {
        if (res.data.code === 404) return toast("warning", res.data.message);
        setIsForgot(false);
        formik.setFieldValue('loginUsername','')
        formik.setFieldValue('loginPassword','')
        toast("success", res.data.result);
      })
      .catch((err) => console.log(err));
  };

  const toast = (type: "warning" | "success", mess: string, title?: string) => {
    return addToast(
      <Toasts
        title={title || "Thông báo"}
        icon={type === "success" ? "CheckCircleOutline" : "WarningAmber"}
        iconColor={type}
        isDismiss={true}
      >
        <div dangerouslySetInnerHTML={{ __html: mess }} />
      </Toasts>,
      {
        autoDismiss: true,
      }
    );
  };
  useEffect(()=>{
    const accoutString= localStorage.getItem('accout');
    if(accoutString){
      const accout:{username:string,password:string}= JSON.parse(accoutString);
      formik.setFieldValue('loginUsername',accout.username)
      formik.setFieldValue('loginPassword',accout.password)
      setIsSave(true)
    }
  },[])
  return (
    <PageWrapper isProtected={false} title={"Login"}>
      <Page className="p-0" container="fluid">
        <div className="row h-100 ">
          <div className="col-md-5">
            <div
              className="d-flex justify-content-center align-items-center h-100"
              style={{ flexDirection: "column" }}
            >
              <Link
                to="/"
                className={classNames(
                  "text-decoration-none  fw-bold display-2",
                  {
                    "text-dark": !darkModeStatus,
                    "text-light": darkModeStatus,
                  }
                )}
              >
                <Logo width={200} height={100} />
              </Link>
              <IconLogo />
            </div>
          </div>
          <div
            className="col-md-7 h-100"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div className="boxlogin" />

            <div className={`boxForm ${isForgot && "isForgot"}`}>
              <form className="row g-4">
                <div className="col-12">
                  <p className="fw-bold fs-4">Đăng nhập</p>

                  <Input
                    id="loginUsername"
                    autoComplete="username"
                    placeholder="Tên đăng nhập"
                    value={formik.values.loginUsername.trim()}
                    isTouched={formik.touched.loginUsername}
                    invalidFeedback={formik.errors.loginUsername}
                    isValid={formik.isValid}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onFocus={() => {
                      formik.setErrors({});
                    }}
                  />

                  <Input
                    id="loginPassword"
                    type="password"
                    className="mt-4"
                    placeholder="Mật khẩu"
                    autoComplete="current-password"
                    value={formik.values.loginPassword.trim()}
                    isTouched={formik.touched.loginPassword}
                    invalidFeedback={formik.errors.loginPassword}
                    isValid={formik.isValid}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                <div className="col-12">
                  <Button
                    color="primary"
                    className="w-100 py-3"
                    onClick={formik.handleSubmit}
                  >
                    Đăng nhập
                  </Button>
                </div>
              </form>
              <div className="row mt-3 fw-bold">
                <div className="col-6 d-flex">
                  <Checks type="checkbox" id="saveAcc"  checked={isSave} onChange={()=>setIsSave(!isSave)}/>{" "}
                  <label htmlFor="saveAcc">Ghi nhớ tài khoản</label>
                </div>
                <div
                  className="col-6 d-flex"
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsForgot(!isForgot)}
                >
                  <p style={{ textAlign: "end" }} className="w-100">
                    Quên mật khẩu
                  </p>
                </div>
              </div>
            </div>
            <div className={`boxFormForgotPassword ${isForgot && "isForgot"}`}>
              <form className="row g-4">
                <div className="col-12">
                  <p className="fw-bold fs-4">Quên mật khẩu</p>
                  <p style={{ fontSize: 16 }}>
                    Mật khẩu mới sẽ được gửi về email đăng ký tài khoản{" "}
                  </p>

                    <Input
                    id="email"
                      autoComplete="email"
                      placeholder="Vui lòng nhập tên tài khoản"
                      value={formikforgotPass.values.email.trim()}
                      isTouched={formikforgotPass.touched.email}
                      invalidFeedback={formikforgotPass.errors.email}
                      isValid={formikforgotPass.isValid}
                      onChange={formikforgotPass.handleChange}
                      onBlur={formikforgotPass.handleBlur}
                      onFocus={() => {
                        formikforgotPass.setErrors({});
                      }}
                    />
                </div>
                <div className="col-12">
                  <Button
                    color="primary"
                    className="w-100 py-2"
                    onClick={formikforgotPass.handleSubmit}
                    style={{ fontSize: 20, fontWeight: "bold" }}
                  >
                    Gửi
                  </Button>
                </div>
              </form>
              <div className="row mt-3 fw-bold">
                <div
                  className="d-flex justify-content-end align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsForgot(!isForgot)}
                >
                  <div
                    className="rounded-circle bg-primary d-flex justify-content-center align-items-center"
                    style={{ width: 25, height: 25, marginRight: 10 }}
                  >
                    <Icon icon="ArrowBackIosNew" color="light" />
                  </div>
                  <p style={{ textAlign: "end", margin: 0 }}>Quay lại đăng nhập</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Page>
    </PageWrapper>
  );
};
Login.propTypes = {
  isSignUp: PropTypes.bool,
};
Login.defaultProps = {
  isSignUp: false,
};

export default Login;
